import { render, staticRenderFns } from "./BlogConfirmationDialog.vue?vue&type=template&id=48d83806&scoped=true&"
import script from "./BlogConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./BlogConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./BlogConfirmationDialog.vue?vue&type=style&index=0&id=48d83806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d83806",
  null
  
)

export default component.exports